import { instance } from '@/services/avik-api-gateway'
import { DailyReportVehicleStatus } from '@/types/daily-report-vehicle-status'
import { AxiosResponse } from 'axios'

export function updateDailyReportVehicleStatus(
  body: Partial<DailyReportVehicleStatus>
): Promise<AxiosResponse<DailyReportVehicleStatus>> {
  return instance.post(`/daily-report/vehicle-status`, body)
}
